import React, { useState } from 'react';
import PropTypes from 'prop-types';
import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded';

const ChallengeCategoryIcon = ({ category }) => {
  const { icon } = category;
  const [iconFailedToLoad, setIconFailedToLoad] = useState(false);

  return iconFailedToLoad ? (
    <StarBorderRoundedIcon />
  ) : (
    <img src={icon} alt="icon" width={24} height={24} onError={() => setIconFailedToLoad(true)} />
  );
};

ChallengeCategoryIcon.propTypes = {
  category: PropTypes.object.isRequired,
};

export default ChallengeCategoryIcon;
